import { Theme } from "@material-ui/core"
import Grid from "@material-ui/core/Grid"
import makeStyles from "@material-ui/core/styles/makeStyles"
import FormControl from "@material-ui/core/FormControl"
import TextField from "@material-ui/core/TextField"
import InputLabel from "@material-ui/core/InputLabel"
import React, { Fragment, useContext } from "react"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import FieldSelect from "Components/Table/FieldSelect"
import { useCreateDraft } from "./hooks"
import ChargePerson from "Components/Calendar/ChargePerson"
import { AppContext } from "Views/Home/context"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "absolute",
        width: "100%",
        height: "100%",
    },
    timeBlock: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: 20,
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
}))

const DraftCreate = () => {
    const classes = useStyles()
    const {
        callback, cancelCallback,
        dialogData, disabled, isBusiness,
        text, handleChange,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange,
        handleChangeAuthor, handleChangeArticleType, staticArticleType,
    } = useCreateDraft()
    const { roleMap } = useContext(AppContext)
    const { isTrueEditor, isOpEditor } = roleMap
    return (
        <Fragment>
            <BoardConfirmModal
                title="创建候选项"
                confirmCallback={callback}
                cancelCallback={cancelCallback}
                modalShow={dialogData.show}
                disabled={disabled}
            >
                <Grid item>
                    <TextField
                        label="内容"
                        value={text}
                        onChange={handleChange}
                        className={classes.input}
                    />
                </Grid>
                <Grid item>
                    <FormControl className={classes.input}>
                        <InputLabel >文章类型</InputLabel>
                        <FieldSelect
                            staticValue={staticArticleType}
                            tableName="article_type"
                            onChange={handleChangeArticleType}
                            // 2026-03 文章类型=“说明” 仅编辑部主编可预约
                            whereQuery={`where: {hidden: {_eq: false}${!isTrueEditor ? ', name: {_neq: "说明"}' : ''}}`}
                        />
                    </FormControl>
                </Grid>
                {/*除编辑部主编和编辑部运营外的角色在预约微信点位时，不再需要填写“负责人”*/}
                {(isTrueEditor || isOpEditor) && (
                    <Grid item>
                        <FormControl className={classes.input}>
                            <InputLabel>负责人</InputLabel>
                            <ChargePerson handleChangeAuthor={handleChangeAuthor} />
                        </FormControl>
                    </Grid>
                )}

                {
                    // 创建时，只对商务部展示项目编号及项目金额
                    isBusiness ? (
                        <>
                            <Grid container direction="column" justify="center">
                                <TextField
                                    label="项目编号"
                                    value={projectId}
                                    onChange={handleProjectIdChange}
                                    error={!!(projectId && projectId.length > 50)}
                                    helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                                />
                            </Grid>
                            <Grid container direction="column" justify="center">
                                <TextField
                                    label="项目金额"
                                    value={projectMoney}
                                    onChange={handleProjectMoneyChange}
                                    error={!!(projectMoney && projectMoney.length > 50)}
                                    helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                                />
                            </Grid>
                        </>
                    ) : null
                }
            </BoardConfirmModal>
        </Fragment>
    )
}

export default DraftCreate
